import { render, staticRenderFns } from "./StatusDoughnutChart.vue?vue&type=template&id=73de245e&scoped=true&"
import script from "./StatusDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./StatusDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./StatusDoughnutChart.vue?vue&type=style&index=0&id=73de245e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73de245e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
